import * as z from "zod";
import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const referenceObject = () =>
  z
    .object({
      id: requiredString(),
    })
    .or(z.literal(undefined)) // <- allow undefined safely
    .refine((val) => !!val && !!val.id?.trim(), {
      message: REQUIRED_MESSAGE,
    });

export const teamSchema = z.object({
  department: requiredString(),
  status: requiredString(),
  lead: referenceObject(),
  employees: z.array(referenceObject()).optional(),
});
